import React, { useMemo } from 'react';
import { sanitizeRichText } from '../../utils/richText';

/**
 * Renders a Circle post body.
 *
 * Posts written before rich text existed are plain text and must keep rendering
 * as plain text — their newlines rely on `white-space: pre-wrap` in the CSS, and
 * pushing them through an HTML renderer would collapse the spacing and expose
 * any stray "<" they contain. So we branch on body_format and only take the
 * HTML path for posts that declare it.
 *
 * The HTML is sanitized here as well as on the server: rows written before the
 * server-side rule landed have never been through an allowlist.
 */
export default function PostBody({ post, className, htmlClassName }) {
  const isHtml = post?.body_format === 'HTML';
  const html = useMemo(
    () => (isHtml ? sanitizeRichText(post?.body) : ''),
    [isHtml, post?.body]
  );

  if (!post?.body) return null;

  if (isHtml) {
    return (
      <div
        className={[className, htmlClassName].filter(Boolean).join(' ')}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return <p className={className}>{post.body}</p>;
}
